import { render } from "./AppFollows.vue?vue&type=template&id=046e7bdc&scoped=true"
import script from "./AppFollows.vue?vue&type=script&lang=js"
export * from "./AppFollows.vue?vue&type=script&lang=js"

import "./AppFollows.vue?vue&type=style&index=0&id=046e7bdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046e7bdc"]])

export default __exports__